export const GET_ALL_USERS_START = 'GET_ALL_USERS_START';
export const GET_ALL_USERS_SUCCESS = 'GET_ALL_USERS_SUCCESS';
export const GET_ALL_USERS_FAILURE = 'GET_ALL_USERS_FAILURE';

export const ASSIGN_ADMIN_ROLE_START = 'ASSIGN_ADMIN_ROLE_START';
export const ASSIGN_ADMIN_ROLE_SUCCESS = 'ASSIGN_ADMIN_ROLE_SUCCESS';
export const ASSIGN_ADMIN_ROLE_FAILURE = 'ASSIGN_ADMIN_ROLE_FAILURE';

export const UPDATE_USERS_START = 'UPDATE_USERS_START';
export const UPDATE_USERS_SUCCESS = 'UPDATE_USERS_SUCCESS';
export const UPDATE_USERS_FAILURE = 'UPDATE_USERS_FAILURE';
